'use strict';

require('./modal.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _makeComponentIntl = require('common/utils/make-component-intl');

var _makeComponentIntl2 = _interopRequireDefault(_makeComponentIntl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Modal = _react2['default'].createClass({
    displayName: 'Modal',
    render: function render() {

        var className = 'm-common-modal--center-content';
        var style = {};
        style.backgroundColor = 'white'; // Default
        // Merge with supplied style props
        style = Object.assign(style, this.props.style);

        if (this.props.className) {
            className += ' ' + this.props.className;
        }

        if (this.props.width) {
            style.width = this.props.width;
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-common-modal' },
            _react2['default'].createElement(
                'div',
                { style: style, className: className },
                this.props.children
            )
        );
    }
});

module.exports = (0, _makeComponentIntl2['default'])(Modal);


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/modal.jsx
 ** module id = 731
 ** module chunks = 0 1
 **/